"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFirefox = void 0;
/* 
    navigator.userAgent in Firefox = Mozilla/5.0 (X11; [Your OS Version]) Gecko/20100101 Firefox/63.0
    navigator.userAgent in Chrome = Mozilla/5.0 (X11; [Your OS Version]) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36
    That's why `navigator.userAgent.indexOf('Chrome') === -1` should be checked for Firefox browser
*/

var isFirefox = exports.isFirefox = function isFirefox() {
  return !!navigator.userAgent.indexOf('Firefox') && navigator.userAgent.indexOf('Chrome') === -1;
};